import { PrismicLink } from "@prismicio/react";
import { isFilled } from "@prismicio/client";

/**
 * @typedef {import("@prismicio/client").Content.BoutonSlice} BoutonSlice
 * @typedef {import("@prismicio/react").SliceComponentProps<BoutonSlice>} BoutonProps
 * @type {import("react").FC<BoutonProps>}
 */
const Bouton = ({ slice, index, slices }) => {
  const isLast = Array.isArray(slices) && index === slices.length - 1;
  const cta = slice?.primary?.cta;
  const anchorId = slice?.primary?.anchor_id?.trim();
  const hasAnchor = isFilled.keyText(anchorId);
  const anchor = hasAnchor ? anchorId.replace(/^#/, "") : "";
  const baseUrl = cta?.url ? cta.url.split("#")[0] : "";
  const href = `${baseUrl}${anchor ? `#${anchor}` : ""}`;

  return (
    <section
      data-slice-type={slice.slice_type}
      data-slice-variation={slice.variation}
      className={`${isLast ? "md:pb-10" : ""} bg-black text-white`}
    >
      {isFilled.link(cta) && (
        <div className="py-4 pr-4 md:pr-10 group transition-all duration-300">
          <PrismicLink field={cta} href={href || undefined} className="flex justify-center items-center gap-5 ">
            <div className="h-[1px] w-full bg-white flex-1  transition-all duration-300"></div>
            <div>
              <img src="/mw-arrow-white.svg" alt="flèche" className="w-6 h-auto lg:w-8" />
            </div>
            <div className="pr-10 group-hover:pr-0 transition-all duration-300 underline underline-offset-4 decoration-1">
              {cta.text}
            </div>
          </PrismicLink>
        </div>
      )}
    </section>
  );
};

export default Bouton;
